/**
 * What deleting a project others have joined does, for both delete dialogs
 * (the Projects dropdown's and the project's own): the owner heads it, so it
 * goes to their Recycle Bin for everyone, each person's own conversations
 * saved to a folder in their regular list, and a restore brings it all back.
 */
export function sharedDeleteMessage(project) {
  const count = project.shared_with || 0;
  const people = count === 1 ? 'The other person in it' : `The ${count} other people in it`;
  return (
    `${people} will lose access too. Everyone's own conversations in it, and a copy of each ` +
    `group chat they're in, move to a "${projectFolderName(project)}" folder in their ` +
    'Conversations now. Its files, instructions and group chats stay in your Recycle Bin for ' +
    '30 days: restore it in that time to bring it back for everyone, conversations included. ' +
    "After that, it's deleted for good."
  );
}

/**
 * What moving a project nobody else has joined to the Recycle Bin does, for
 * the same two dialogs: its conversations go straight to a folder in the
 * regular list, and a restore brings them back with it.
 */
export function recycleBinMessage(project) {
  return (
    `Any conversations in it move to a "${projectFolderName(project)}" folder in your ` +
    'Conversations now. Its files and instructions stay in the Recycle Bin for 30 days: ' +
    'restore it in that time to get everything back, conversations included. After that, ' +
    'its files and instructions are deleted for good.'
  );
}

/** The folder a project's conversations are saved to when they leave it --
 * the backend's _archive_members_conversations names it the same way. */
export function projectFolderName(project) {
  return `Project-${(project.name || 'Untitled').trim()}`.slice(0, 100);
}
